import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#micro-credential", label: "Micro-Credential" },
  { href: "#workshops", label: "Workshops" },
  { href: "#accreditation", label: "NZQA" },
  { href: "#team", label: "About" },
  { href: "#calendar", label: "Calendar" },
  { href: "#register", label: "Enrol" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "nav-glass" : "bg-transparent"
      }`}
    >
      <div className="container-pl flex items-center justify-between py-4">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-10 h-10 rounded-lg bg-[var(--forest)] text-white flex items-center justify-center font-display font-bold">
            PL
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-[var(--forest)] text-[1.02rem]">
              Paraprofessionals
            </div>
            <div className="text-[0.72rem] tracking-widest uppercase text-[var(--slate)]">
              Learning Community
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[0.92rem] font-medium text-[var(--charcoal)] hover:text-[var(--forest)] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#register" className="btn btn-primary" data-testid="nav-register-cta">
            Enrol now
          </a>
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 rounded-md text-[var(--forest)]"
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden nav-glass border-t border-black/5" data-testid="nav-mobile-menu">
          <div className="container-pl py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-[var(--charcoal)] font-medium"
                data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#register"
              onClick={() => setOpen(false)}
              className="btn btn-primary mt-2"
              data-testid="nav-mobile-register-cta"
            >
              Enrol now
            </a>
            <Link
              to="/admin"
              onClick={() => setOpen(false)}
              className="text-xs text-[var(--slate)] underline mt-2"
              data-testid="nav-mobile-admin-link"
            >
              Admin
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
